/** Single-line text that ellipsizes instead of wrapping or overflowing. */
export const textOverflowHidden = {
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
} as const;
